export default __webpack_public_path__ + "static/media/gift.c80c5f0f.svg";